/* eslint-disable */
import React from 'react';
import DocumentTitle from 'react-document-title';
import { jsConfigAppBar, registerWindowFn, openNativePage } from '@/utils/bridge';
import { useMounted } from '@/utils/hooks';
import { reportPage } from '@/utils/report';
import { useDebounceEffect } from 'ahooks';

const NativeNav = ({
  isInterceptBack = false,
  interceptBackName = 'interceptNativeBack',
  children,
  title,
  titleColor, // 标题栏字体颜色,AHEX格式，不要#号
  trailing = {},
  pageName,
  otherReportData = {},
  elevation = 0,
  backgroundColor, // 导航栏背景颜色
  darkBrightness = 1, // 系统状态栏字体颜色
}) => {
  // 拦截左上角返回键
  const interceptNativeBack = () => {
    openNativePage(
      {
        path: '/home',
        tab: 4,
      },
      false
    );
    return true;
  };

  const handleInitNavBar = () => {
    const titleConfig = {
      text: title,
      registed: 1,
      dark_brightness: darkBrightness,
      background_color: 'FFFFFFFF',
      text_color: 'FF000000',
    };
    if (titleColor) titleConfig.text_color = titleColor;
    if (backgroundColor) titleConfig.background_color = backgroundColor;
    jsConfigAppBar({
      style: 2,
      trailing,
      title: titleConfig,
      leading: { js_callback: interceptBackName, registed: isInterceptBack ? 1 : 0 },
      // 标题栏阴影设置
      elevation,
    });
  };

  const handleReportPage = () => {
    if (pageName)
      reportPage({
        page_name: pageName,
        ...otherReportData,
      });
  };

  useDebounceEffect(
    () => {
      handleInitNavBar();
    },
    [title, titleColor, backgroundColor, darkBrightness],
    { wait: 16.7, maxWait: 16.7 }
  );

  useMounted(() => {
    handleReportPage();
    registerWindowFn('interceptNativeBack', interceptNativeBack);
  });

  return <DocumentTitle title={title}>{children}</DocumentTitle>;
};

export default NativeNav;
